import React from 'react';
import { connect } from 'react-redux';
import { RenderProps } from './hoc';

export function connectFactory({ state: mapStateToProps, ...mapDispatchToProps }) {
  return connect(mapStateToProps, mapDispatchToProps)(RenderProps);
}